var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_329)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_839_329)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_839_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 0H16C7.16344 0 0 7.16344 0 16V44C0 52.8366 7.16344 60 16 60H44C52.8366 60 60 52.8366 60 44V16C60 7.16344 52.8366 0 44 0Z",
    fill: "#CAD6FF"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M21 25.2919V22.7119H25.82V37.2919H22.94V25.2919H21Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8981 30.4001C30.3541 30.4001 29.8661 30.3041 29.4341 30.1121C29.0021 29.9121 28.6581 29.6441 28.4021 29.3081C28.1541 28.9721 28.0181 28.6001 27.9941 28.1921H29.6861C29.7181 28.4481 29.8421 28.6601 30.0581 28.8281C30.2821 28.9961 30.5581 29.0801 30.8861 29.0801C31.2061 29.0801 31.4541 29.0161 31.6301 28.8881C31.8141 28.7601 31.9061 28.5961 31.9061 28.3961C31.9061 28.1801 31.7941 28.0201 31.5701 27.9161C31.3541 27.8041 31.0061 27.6841 30.5261 27.5561C30.0301 27.4361 29.6221 27.3121 29.3021 27.1841C28.9901 27.0561 28.7181 26.8601 28.4861 26.5961C28.2621 26.3321 28.1501 25.9761 28.1501 25.5281C28.1501 25.1601 28.2541 24.8241 28.4621 24.5201C28.6781 24.2161 28.9821 23.9761 29.3741 23.8001C29.7741 23.6241 30.2421 23.5361 30.7781 23.5361C31.5701 23.5361 32.2021 23.7361 32.6741 24.1361C33.1461 24.5281 33.4061 25.0601 33.4541 25.7321H31.8461C31.8221 25.4681 31.7101 25.2601 31.5101 25.1081C31.3181 24.9481 31.0581 24.8681 30.7301 24.8681C30.4261 24.8681 30.1901 24.9241 30.0221 25.0361C29.8621 25.1481 29.7821 25.3041 29.7821 25.5041C29.7821 25.7281 29.8941 25.9001 30.1181 26.0201C30.3421 26.1321 30.6901 26.2481 31.1621 26.3681C31.6421 26.4881 32.0381 26.6121 32.3501 26.7401C32.6621 26.8681 32.9301 27.0681 33.1541 27.3401C33.3861 27.6041 33.5061 27.9561 33.5141 28.3961C33.5141 28.7801 33.4061 29.1241 33.1901 29.4281C32.9821 29.7321 32.6781 29.9721 32.2781 30.1481C31.8861 30.3161 31.4261 30.4001 30.8981 30.4001Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2091 25.024V28.24C37.2091 28.464 37.2611 28.628 37.3651 28.732C37.4771 28.828 37.6611 28.876 37.9171 28.876H38.6971V30.292H37.6411C36.2251 30.292 35.5171 29.604 35.5171 28.228V25.024H34.7251V23.644H35.5171V22H37.2091V23.644H38.6971V25.024H37.2091Z",
    fill: "#2A2A2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_839_329",
    x: -3,
    y: -3,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_839_329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_839_329",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_839_329",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_839_329"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirst);
export default __webpack_public_path__ + "static/media/first.72ad8a9dc2f5ad036c916dd5df4927e8.svg";
export { ForwardRef as ReactComponent };